(() => {
  function initialiseChecklist(objRoot) {
    if (objRoot.dataset.ready) return;
    objRoot.dataset.ready = 'true';
    const strStorageKey = 'lucid:first-doll-checklist:v1';
    const arrInputs = Array.from(objRoot.querySelectorAll('[data-check]'));
    const objCount = objRoot.querySelector('[data-check-count]');
    const objProgress = objRoot.querySelector('[data-check-progress]');
    const objStatus = objRoot.querySelector('[data-check-status]');
    const objReset = objRoot.querySelector('[data-check-reset]');
    const objDone = objRoot.querySelector('[data-check-done]');
    const objSaving = objRoot.querySelector('[data-check-saving]');
    let boolCanSave = true;
    try {
      const arrSaved = JSON.parse(localStorage.getItem(strStorageKey) || '[]');
      if (Array.isArray(arrSaved)) arrInputs.forEach((objInput) => { objInput.checked = arrSaved.includes(objInput.dataset.check); });
      localStorage.setItem(strStorageKey, JSON.stringify(arrInputs.filter((objInput) => objInput.checked).map((objInput) => objInput.dataset.check)));
    } catch { boolCanSave = false; }
    objSaving.hidden = false;
    objSaving.textContent = boolCanSave ? 'Vos cases cochées sont enregistrées dans ce navigateur.' : 'Vos cases cochées resteront sur cette page tant qu’elle est ouverte. Le stockage du navigateur n’est pas disponible.';
    function updateChecklist(boolPersist) {
      const arrChecked = arrInputs.filter((objInput) => objInput.checked);
      const intCount = arrChecked.length;
      objCount.textContent = String(intCount);
      objProgress.value = intCount;
      objProgress.textContent = `${intCount} sur ${arrInputs.length}`;
      objStatus.textContent = intCount === arrInputs.length ? 'Les quinze vérifications sont terminées.' : intCount === 0 ? 'Prêt quand vous l’êtes.' : `${arrInputs.length - intCount} vérifications restantes. Prenez votre temps.`;
      objReset.disabled = intCount === 0;
      objDone.hidden = intCount !== arrInputs.length;
      objRoot.querySelectorAll('.ld-check-group').forEach((objGroup) => {
        const intGroupCount = objGroup.querySelectorAll('input:checked').length;
        objGroup.querySelector('[data-group-count]').textContent = `${intGroupCount} / 3`;
        objGroup.classList.toggle('ld-check-complete', intGroupCount === 3);
      });
      if (boolPersist && boolCanSave) {
        try { localStorage.setItem(strStorageKey, JSON.stringify(arrChecked.map((objInput) => objInput.dataset.check))); }
        catch { boolCanSave = false; objSaving.textContent = 'Vos cases cochées resteront sur cette page tant qu’elle est ouverte. Le stockage du navigateur n’est pas disponible.'; }
      }
    }
    arrInputs.forEach((objInput) => objInput.addEventListener('change', () => updateChecklist(true)));
    objReset.addEventListener('click', () => { arrInputs.forEach((objInput) => { objInput.checked = false; }); updateChecklist(true); arrInputs[0].focus({ preventScroll: true }); });
    updateChecklist(false);
  }
  document.querySelectorAll('[data-buying-checklist]').forEach(initialiseChecklist);
  document.addEventListener('shopify:section:load', (objEvent) => objEvent.target.querySelectorAll('[data-buying-checklist]').forEach(initialiseChecklist));
})();
